import { vmAddLiveElement } from './components';
import { fetchLive } from './fetchLive';

const $elementArea = document.querySelector('.js-sidebar-live');

const addSidebarLive = () => {
  function liveBanner () {
    fetchLive('banner').then(res => {
      if (res[0] && new Date(res[0].start_date) < new Date()) {
        vmAddLiveElement.$data.bannerValue = res[0];
        vmAddLiveElement.$data.isBannerActive = true;
      }
    }).catch(err => {
      throw err;
    });
  }

  function livePlan () {
    fetchLive('plan').then(res => {
      if (res[0]) {
        res.forEach((x, i) => {
          if (new Date(x.start_date) > new Date()) {
            vmAddLiveElement.$data.planValue.push(x);
            vmAddLiveElement.$data.isPlanActive = true;
          }
        });
      }
    }).catch(err => {
      throw err;
    });
  }

  function init () {
    liveBanner();
    livePlan();
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  if ($elementArea !== null) {
    vmAddLiveElement.$mount('.js-sidebar-live');
    addSidebarLive();
  }
});
